import {Dropdown, DropdownButton, ListGroup} from "react-bootstrap";
import Icon from "../../components/icon";
import {deleteSender} from "./api";
import {useEnterprise} from "./EnterpriseProvider";

export const SendersList = ({senders, setSender, setSenders}) => {
    const {enterprise, domain} = useEnterprise();

    const handleDelete = async (id) => {
        await deleteSender(id, () => {
            setSenders(prev => prev.filter(sender => sender._id?.$oid !== id));
        })
    }

    return (
        <div className="max-width-600">
            <strong className="d-block mb-3" style={{color: '#087366'}}>Senders List</strong>
            <ListGroup>
                {senders?.length > 0 && senders.map((sender, index) => (
                    <ListGroup.Item key={`sender-${index}`}>
                        <div className="d-flex align-items-center justify-content-between">
                            <div>
                                <strong>{sender.name}</strong>
                                <p className="mb-0">{sender.email}</p>
                            </div>
                            <div>
                                <DropdownButton size="sm" variant="white" id="dropdown-basic-button" title={<Icon name="menu" />}>
                                    <Dropdown.Item onClick={ev => setSender(sender)}>
                                        <Icon name="edit" className="me-2" />
                                        Edit
                                    </Dropdown.Item>
                                    <Dropdown.Item onClick={ev => handleDelete(sender._id?.$oid)}>
                                        <Icon name="delete" className="me-2" />
                                        Delete
                                    </Dropdown.Item>
                                </DropdownButton>
                            </div>
                        </div>
                    </ListGroup.Item>
                ))}
                {!senders?.length && <ListGroup.Item>
                    <div className="d-flex align-items-center justify-content-between">
                        <div>
                            <strong>{enterprise?.name}</strong>
                            <p className="mb-0">{`noreply@${domain.email_subdomain}.${domain?.name}`}</p>
                        </div>
                    </div>
                </ListGroup.Item>}
            </ListGroup>
        </div>
    )
}